import { z } from 'zod'
import { StrapiID, StrapiIdSchema } from './common'

export type RemoteImage = {
  id: StrapiID
  url: string
  width: number
  height: number
  remote?: boolean
  alt?: string | null
}

export const RemoteImageSchema = z.object({
  id: StrapiIdSchema,
  url: z.string(),
  width: z.number(),
  height: z.number(),
  remote: z.boolean().optional(),
  alt: z.string().nullish(),
})
